var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"form__label primary--text",attrs:{"for":_vm.idElement}},[_vm._v(" "+_vm._s(_vm.labelText)+" ")]),_c('BaseSelect',_vm._g(_vm._b({ref:"selectInput",attrs:{"id":_vm.idElement}},'BaseSelect',_vm.defaultConfigs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }